import { flexCenter } from '@/styles/layout';
import styled, { keyframes } from 'styled-components';

const hoverAnimation = keyframes`
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(30%);
  }
`;

export const GetStartedBlock = styled.span`
  margin-left: 12px;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 600;
  transition: transform 0.3s linear;
  cursor: pointer;

  & > svg {
    display: inline;
    vertical-align: middle;
    margin-left: 4px;
  }

  &:hover > svg {
    animation: ${hoverAnimation} 1s ease-in-out infinite;
  }
`;

export const CompletePaymentBlock = styled(GetStartedBlock)`
  margin-left: 4px;
`;

export const StripeLink = styled.a`
  text-decoration: none;
  ${flexCenter};
  cursor: pointer;
`;
